<template>
  <div class="event-card" :class="{ inactive: !event.is_active, hasThumbnail: event.thumbnail }">
    <div class="header thumbnail" :style="{ backgroundImage: `url(${event.thumbnail?.url})` }">
      <div v-if="!event.thumbnail" :id="`event-map-${event.id}`" class="map" />

      <div v-if="!(event.is_active && event.is_reviewed)" class="inactive-event">
        <h1>Ez az esemény {{ event.is_reviewed ? 'már véget ért' : 'még elfogadásra vár' }}.</h1>
      </div>

      <div class="visit-button" v-if="event.is_active && isVisitor">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
          <path
            d="M10.1127 17.0335C9.42886 17.8456 8.70635 18.273 7.7742 18.2771C6.6772 18.2811 5.82036 17.8273 5.2973 16.8605C4.76813 15.8816 4.83326 14.8884 5.45401 13.9705C5.74709 13.539 6.12565 13.1645 6.47978 12.7778C7.61545 11.5383 8.78572 10.3029 9.93971 9.05127C11.3094 10.4536 12.8562 12.0065 14.2158 13.421C15.209 14.4549 15.3759 15.8388 14.6798 16.944C13.7741 18.3829 11.686 18.6556 10.4465 17.4894C10.3264 17.3755 10.247 17.2167 10.1127 17.0335Z"
            fill="#2FE449"
          />
          <path
            d="M15.9848 4.59611C15.9848 5.54657 15.8077 6.10423 15.5411 6.90002C15.4149 7.28061 15.1503 7.63881 14.8817 7.94614C13.9231 9.0411 12.5981 9.03092 11.6314 7.94817C11.0941 7.34574 10.7867 6.62933 10.6158 5.84779C10.3207 4.5147 10.3919 3.20603 10.9353 1.94825C11.1042 1.55748 11.3363 1.17689 11.611 0.85328C12.5757 -0.286461 13.9495 -0.282391 14.9203 0.85328C15.7955 1.88108 15.9848 3.31187 15.9848 4.59611Z"
            fill="#2FE449"
          />
          <path
            d="M9.53142 4.70814C9.52125 5.5202 9.29737 6.58261 8.67662 7.52696C7.5959 9.17348 5.8639 9.16941 4.77097 7.53103C3.61901 5.80514 3.62919 2.91101 4.79335 1.19733C5.87407 -0.392204 7.56537 -0.394239 8.65016 1.19326C9.21799 2.02364 9.53549 3.18373 9.53142 4.70814Z"
            fill="#2FE449"
          />
          <path
            d="M14.8857 10.8036C14.9712 9.37081 15.5126 8.10692 16.632 7.13814C16.9597 6.85524 17.3769 6.63136 17.79 6.49704C18.6245 6.22635 19.3633 6.59269 19.7337 7.39051C20.0309 8.02958 20.0512 8.69918 19.9311 9.38506C19.7215 10.5614 19.2107 11.5831 18.3151 12.3789C17.6578 12.963 16.9067 13.4026 16.0011 13.0098C15.0689 12.6028 14.8857 11.921 14.8857 10.8036Z"
            fill="#2FE449"
          />
          <path
            d="M5.10013 10.7468C5.04925 11.8581 4.91289 12.5643 4.04384 12.9836C3.14629 13.413 2.36882 13.0141 1.72365 12.4178C0.433299 11.2251 -0.224088 9.75159 0.0689888 7.97889C0.305078 6.55217 1.53234 5.9823 2.77587 6.72721C4.3186 7.65325 4.82944 8.92528 5.10013 10.7468Z"
            fill="#2FE449"
          />
          <circle cx="14.5" cy="16" r="4.5" fill="#E6224A" />
          <path
            d="M13.8153 18.2502L11.8003 16.3722L12.7613 15.4767L13.8153 16.4589L16.2393 14.2002L17.2003 15.0958L13.8153 18.2502Z"
            fill="white"
          />
        </svg>
      </div>
    </div>
    <div class="footer">
      <div class="title">
        <svg
          width="32"
          height="39"
          viewBox="0 0 60 73"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          v-if="event.is_active && event.thumbnail"
        >
          <path
            d="M48.9135 27.3358C47.8556 22.6374 45.5942 18.5814 42.1846 15.2106C38.3871 11.4551 33.8341 9.15279 28.5463 8.31169C23.8619 7.56599 19.3422 8.16541 15.0158 10.0336C10.0305 12.1849 6.13314 15.6399 3.39661 20.3621C0.428877 25.4851 -0.597322 30.9912 0.330689 36.8439C0.991065 41.016 2.67447 44.754 5.19087 48.1295C10.0004 54.5785 14.7988 61.0338 19.5956 67.4923C20.9528 69.3208 22.2894 71.1636 23.6371 73H25.8573C25.9523 72.8664 26.0505 72.7361 26.1503 72.6089C26.1693 72.5787 26.1899 72.55 26.2105 72.5214C31.0738 65.9818 35.9594 59.4581 40.7926 52.8963C42.769 50.214 44.8594 47.5778 46.4937 44.6904C49.5549 39.2845 50.2833 33.4222 48.9135 27.3358Z"
            fill="#2FE449"
          />
          <path
            d="M34.667 40.4766C34.5673 40.3208 34.4675 40.1666 34.3677 40.0107C34.3392 40.0648 34.3123 40.1189 34.2838 40.1745C33.9877 40.0616 33.6123 40.0282 33.4096 39.8231C31.3731 37.772 29.3634 35.6955 27.3522 33.6206C27.1004 33.3614 26.9025 33.2136 26.4717 33.309C25.6245 33.4966 25.0259 32.8622 24.4478 32.3931C23.3044 31.4646 22.2292 30.455 21.1016 29.4565C20.8926 30.4041 20.6693 31.4169 20.446 32.4281C20.3114 33.0403 20.115 33.6461 20.0659 34.2646C20.0406 34.573 20.2338 34.9339 20.4096 35.2185C21.0969 36.3268 21.9045 37.3682 22.4936 38.5241C22.907 39.335 23.0479 40.289 23.2949 41.1826C23.6481 42.4577 23.9917 43.7376 24.3354 45.016C24.6331 46.1258 24.1754 47.0655 23.1857 47.3024C22.2244 47.5329 21.1824 46.9033 20.9654 45.9604C20.5869 44.31 20.1467 42.666 19.5845 41.0697C19.1822 39.9281 18.5409 38.8707 18.0072 37.7768C17.9327 37.7943 17.8583 37.8134 17.7839 37.8309C17.7221 38.2443 17.5796 38.664 17.6129 39.0711C17.7316 40.5275 16.9588 41.7247 16.536 43.0222C16.2208 43.9936 15.8107 44.9333 15.4607 45.8937C14.9745 47.2308 13.8644 47.7078 12.702 47.0639C11.9941 46.6712 11.7138 45.8905 12.0385 45.0001C12.6339 43.3624 13.2895 41.7454 13.8818 40.1061C14.0528 39.6323 14.1384 39.1172 14.1859 38.6131C14.3015 37.3984 14.3743 36.1805 14.4567 34.9626C14.4646 34.8513 14.4598 34.7113 14.3997 34.6255C13.6934 33.5999 13.9895 32.549 14.2635 31.4726C14.52 30.4677 14.691 29.439 14.7702 28.326C14.0069 29.1385 13.2214 29.9303 12.4866 30.7682C12.0305 31.2881 11.6315 31.9177 10.8381 31.7428C10.4216 31.6522 9.94014 31.4153 9.69467 31.0878C9.33677 30.614 9.43654 30.0066 9.81978 29.5312C11.386 27.5866 13.0219 25.693 15.2675 24.5212C16.2984 23.9837 17.4592 23.6991 18.5124 23.3175C17.9153 22.8374 17.4086 22.0805 17.2233 21.1409C17.0364 20.1901 17.3136 19.314 17.8124 18.5317C18.5741 17.3345 20.6186 16.7811 21.9821 17.414C23.5309 18.1326 24.1802 19.5906 23.9759 21.0312C23.7083 22.9216 22.4825 23.8359 20.3747 23.9329C21.5355 25.3289 22.6615 26.8123 23.9284 28.1606C24.7535 29.0399 25.7765 29.7331 26.7267 30.4915C27.3174 30.9622 27.8115 31.4519 27.6753 32.3089C27.6547 32.4424 27.7893 32.6348 27.9017 32.7525C29.7609 34.6779 31.6233 36.6002 33.4967 38.5114C33.853 38.8739 34.26 39.1855 34.7304 39.5973C35.1722 38.7976 35.6536 37.9628 36.0971 37.1074C36.2602 36.791 36.3536 36.3411 36.7954 36.5176C37.0868 36.6336 37.4558 36.9866 37.4812 37.2617C37.5841 38.3699 38.3791 38.8834 39.1376 39.4495C39.2469 39.5322 39.391 39.5671 39.513 39.6339C39.9231 39.8549 40.2446 40.2158 40.0451 40.6531C39.893 40.9886 39.5003 41.2334 39.1741 41.4576C39.0442 41.5467 38.794 41.5164 38.6166 41.4703C38.0101 41.3129 37.4558 41.3781 36.9554 41.7756C36.1905 41.34 35.4288 40.9075 34.667 40.4766Z"
            fill="white"
          />
          <path
            d="M34.4628 40.7946C35.2245 41.2255 35.9878 41.658 36.7495 42.0888C36.7939 42.4577 36.8715 42.8266 36.8778 43.1971C36.8952 44.2671 36.8968 45.3388 36.8778 46.4088C36.8699 46.862 36.7479 47.2451 36.1509 47.2245C35.5681 47.2038 35.4525 46.8683 35.4684 46.377C35.4842 45.8332 35.4715 45.2895 35.4715 44.6964C34.3725 44.6964 33.3178 44.6964 32.1491 44.6964C32.3961 45.0939 32.621 45.4532 32.8443 45.8158C33.1578 46.3214 33.1119 46.943 32.7477 47.1545C32.3217 47.4025 31.8181 47.1641 31.5124 46.5837C31.2622 46.1099 30.9978 45.6456 30.6985 45.105C30.4229 45.6472 30.1774 46.1528 29.9098 46.6473C29.6786 47.075 29.3286 47.4169 28.8313 47.1529C28.3404 46.8922 28.4022 46.3977 28.6397 45.9779C29.2542 44.8936 29.6279 43.7806 29.5266 42.4927C29.4806 41.9187 29.2573 41.5737 28.8646 41.2541C28.7031 41.1221 28.5225 41.0108 28.3689 40.8709C28.0079 40.5434 28.0379 40.0728 28.3246 39.8374C28.5447 39.6562 29.2019 39.6164 29.3286 39.777C30.1949 40.882 31.3731 40.6388 32.507 40.6658C33.1578 40.6801 33.8103 40.7501 34.4628 40.7946Z"
            fill="white"
          />
          <circle cx="44" cy="16" r="16" fill="#FF2870" />
          <path
            d="M53.4117 16.5899C53.2889 17.2355 53.2235 17.8975 53.0435 18.5267C52.2989 21.1419 50.7033 23.095 48.2895 24.3372C45.7694 25.6366 43.1429 25.7592 40.5082 24.6968C38.0207 23.6998 36.2615 21.9182 35.2715 19.4338C34.3469 17.1129 34.3632 14.7756 35.3042 12.4629C36.1634 10.3463 37.6362 8.74448 39.6572 7.68208C41.8992 6.50527 44.2638 6.27645 46.6858 7.00378C49.2305 7.77198 51.1206 9.37375 52.3561 11.7192C52.9371 12.8143 53.2644 13.9829 53.3626 15.2169C53.3708 15.2823 53.3953 15.3559 53.4035 15.4212C53.4117 15.8135 53.4117 16.1976 53.4117 16.5899ZM45.573 14.4406C45.573 14.2935 45.573 14.1791 45.573 14.0728C45.573 13.1248 45.5894 12.1768 45.5648 11.2289C45.5403 10.3217 44.9021 9.73333 44.002 9.7415C43.0938 9.7415 42.4637 10.3381 42.4555 11.237C42.4392 12.847 42.4392 14.4569 42.4555 16.0669C42.4637 16.9413 43.0447 17.5379 43.912 17.5542C45.0248 17.5787 46.1376 17.5706 47.2504 17.5542C47.7577 17.546 48.1913 17.3417 48.4614 16.8923C48.7887 16.3447 48.805 15.7645 48.5186 15.2006C48.2486 14.6694 47.7659 14.4487 47.1849 14.4406C46.6531 14.4324 46.1376 14.4406 45.573 14.4406Z"
            fill="white"
          />
        </svg>

        <svg
          width="32"
          height="39"
          viewBox="0 0 60 73"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          v-else-if="!event.is_active && event.thumbnail"
        >
          <path
            d="M48.9135 27.3358C47.8556 22.6374 45.5942 18.5814 42.1846 15.2106C38.3871 11.4551 33.8341 9.15279 28.5463 8.31169C23.8619 7.56599 19.3422 8.16541 15.0158 10.0336C10.0305 12.1849 6.13314 15.6399 3.39661 20.3621C0.428877 25.4851 -0.597322 30.9912 0.330689 36.8439C0.991065 41.016 2.67447 44.754 5.19087 48.1295C10.0004 54.5785 14.7988 61.0338 19.5956 67.4923C20.9528 69.3208 22.2894 71.1636 23.6371 73H25.8573C25.9523 72.8664 26.0505 72.7361 26.1503 72.6089C26.1693 72.5787 26.1899 72.55 26.2105 72.5214C31.0738 65.9818 35.9594 59.4581 40.7926 52.8963C42.769 50.214 44.8594 47.5778 46.4937 44.6904C49.5549 39.2845 50.2833 33.4222 48.9135 27.3358Z"
            fill="#D6D6D6"
          />
          <path
            d="M34.667 40.4766C34.5673 40.3208 34.4675 40.1666 34.3677 40.0107C34.3392 40.0648 34.3123 40.1189 34.2838 40.1745C33.9877 40.0616 33.6123 40.0282 33.4096 39.8231C31.3731 37.772 29.3634 35.6955 27.3522 33.6206C27.1004 33.3614 26.9025 33.2136 26.4717 33.309C25.6245 33.4966 25.0259 32.8622 24.4478 32.3931C23.3044 31.4646 22.2292 30.455 21.1016 29.4565C20.8926 30.4041 20.6693 31.4169 20.446 32.4281C20.3114 33.0403 20.115 33.6461 20.0659 34.2646C20.0406 34.573 20.2338 34.9339 20.4096 35.2185C21.0969 36.3268 21.9045 37.3682 22.4936 38.5241C22.907 39.335 23.0479 40.289 23.2949 41.1826C23.6481 42.4577 23.9917 43.7376 24.3354 45.016C24.6331 46.1258 24.1754 47.0655 23.1857 47.3024C22.2244 47.5329 21.1824 46.9033 20.9654 45.9604C20.5869 44.31 20.1467 42.666 19.5845 41.0697C19.1822 39.9281 18.5409 38.8707 18.0072 37.7768C17.9327 37.7943 17.8583 37.8134 17.7839 37.8309C17.7221 38.2443 17.5796 38.664 17.6129 39.0711C17.7316 40.5275 16.9588 41.7247 16.536 43.0222C16.2208 43.9936 15.8107 44.9333 15.4607 45.8937C14.9745 47.2308 13.8644 47.7078 12.702 47.0639C11.9941 46.6712 11.7138 45.8905 12.0385 45.0001C12.6339 43.3624 13.2895 41.7454 13.8818 40.1061C14.0528 39.6323 14.1384 39.1172 14.1859 38.6131C14.3015 37.3984 14.3743 36.1805 14.4567 34.9626C14.4646 34.8513 14.4598 34.7113 14.3997 34.6255C13.6934 33.5999 13.9895 32.549 14.2635 31.4726C14.52 30.4677 14.691 29.439 14.7702 28.326C14.0069 29.1385 13.2214 29.9303 12.4866 30.7682C12.0305 31.2881 11.6315 31.9177 10.8381 31.7428C10.4216 31.6522 9.94014 31.4153 9.69467 31.0878C9.33677 30.614 9.43654 30.0066 9.81978 29.5312C11.386 27.5866 13.0219 25.693 15.2675 24.5212C16.2984 23.9837 17.4592 23.6991 18.5124 23.3175C17.9153 22.8374 17.4086 22.0805 17.2233 21.1409C17.0364 20.1901 17.3136 19.314 17.8124 18.5317C18.5741 17.3345 20.6186 16.7811 21.9821 17.414C23.5309 18.1326 24.1802 19.5906 23.9759 21.0312C23.7083 22.9216 22.4825 23.8359 20.3747 23.9329C21.5355 25.3289 22.6615 26.8123 23.9284 28.1606C24.7535 29.0399 25.7765 29.7331 26.7267 30.4915C27.3174 30.9622 27.8115 31.4519 27.6753 32.3089C27.6547 32.4424 27.7893 32.6348 27.9017 32.7525C29.7609 34.6779 31.6233 36.6002 33.4967 38.5114C33.853 38.8739 34.26 39.1855 34.7304 39.5973C35.1722 38.7976 35.6536 37.9628 36.0971 37.1074C36.2602 36.791 36.3536 36.3411 36.7954 36.5176C37.0868 36.6336 37.4558 36.9866 37.4812 37.2617C37.5841 38.3699 38.3791 38.8834 39.1376 39.4495C39.2469 39.5322 39.391 39.5671 39.513 39.6339C39.9231 39.8549 40.2446 40.2158 40.0451 40.6531C39.893 40.9886 39.5003 41.2334 39.1741 41.4576C39.0442 41.5467 38.794 41.5164 38.6166 41.4703C38.0101 41.3129 37.4558 41.3781 36.9554 41.7756C36.1905 41.34 35.4288 40.9075 34.667 40.4766Z"
            fill="white"
          />
          <path
            d="M34.4628 40.7946C35.2245 41.2255 35.9878 41.658 36.7495 42.0888C36.7939 42.4577 36.8715 42.8266 36.8778 43.1971C36.8952 44.2671 36.8968 45.3388 36.8778 46.4088C36.8699 46.862 36.7479 47.2451 36.1509 47.2245C35.5681 47.2038 35.4525 46.8683 35.4684 46.377C35.4842 45.8332 35.4715 45.2895 35.4715 44.6964C34.3725 44.6964 33.3178 44.6964 32.1491 44.6964C32.3961 45.0939 32.621 45.4532 32.8443 45.8158C33.1578 46.3214 33.1119 46.943 32.7477 47.1545C32.3217 47.4025 31.8181 47.1641 31.5124 46.5837C31.2622 46.1099 30.9978 45.6456 30.6985 45.105C30.4229 45.6472 30.1774 46.1528 29.9098 46.6473C29.6786 47.075 29.3286 47.4169 28.8313 47.1529C28.3404 46.8922 28.4022 46.3977 28.6397 45.9779C29.2542 44.8936 29.6279 43.7806 29.5266 42.4927C29.4806 41.9187 29.2573 41.5737 28.8646 41.2541C28.7031 41.1221 28.5225 41.0108 28.3689 40.8709C28.0079 40.5434 28.0379 40.0728 28.3246 39.8374C28.5447 39.6562 29.2019 39.6164 29.3286 39.777C30.1949 40.882 31.3731 40.6388 32.507 40.6658C33.1578 40.6801 33.8103 40.7501 34.4628 40.7946Z"
            fill="white"
          />
          <circle cx="44" cy="16" r="16" fill="#6A6A6A" />
          <path
            d="M53.4117 16.5899C53.2889 17.2355 53.2235 17.8975 53.0435 18.5267C52.2989 21.1419 50.7033 23.095 48.2895 24.3372C45.7694 25.6366 43.1429 25.7592 40.5082 24.6968C38.0207 23.6998 36.2615 21.9182 35.2715 19.4338C34.3469 17.1129 34.3632 14.7756 35.3042 12.4629C36.1634 10.3463 37.6362 8.74448 39.6572 7.68208C41.8992 6.50527 44.2638 6.27645 46.6858 7.00378C49.2305 7.77198 51.1206 9.37375 52.3561 11.7192C52.9371 12.8143 53.2644 13.9829 53.3626 15.2169C53.3708 15.2823 53.3953 15.3559 53.4035 15.4212C53.4117 15.8135 53.4117 16.1976 53.4117 16.5899ZM45.573 14.4406C45.573 14.2935 45.573 14.1791 45.573 14.0728C45.573 13.1248 45.5894 12.1768 45.5648 11.2289C45.5403 10.3217 44.9021 9.73333 44.002 9.7415C43.0938 9.7415 42.4637 10.3381 42.4555 11.237C42.4392 12.847 42.4392 14.4569 42.4555 16.0669C42.4637 16.9413 43.0447 17.5379 43.912 17.5542C45.0248 17.5787 46.1376 17.5706 47.2504 17.5542C47.7577 17.546 48.1913 17.3417 48.4614 16.8923C48.7887 16.3447 48.805 15.7645 48.5186 15.2006C48.2486 14.6694 47.7659 14.4487 47.1849 14.4406C46.6531 14.4324 46.1376 14.4406 45.573 14.4406Z"
            fill="white"
          />
        </svg>

        <h1>{{ event.name }}</h1>

        <p v-if="event.is_active">{{ dateString }}</p>
      </div>

      <div class="visitors" v-if="event.is_active">
        <div class="visitor" v-for="pet in event.visitors" :key="pet.id" @click="goToPet(pet.id)">
          <ion-img :src="pet.avatar" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { IonImg } from '@ionic/vue'
import { computed, defineComponent, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import usePets from '@/composables/pets'

import { MAPS_API } from '@/constants/types'
import { PET_ROUTE } from '@/constants/routes'
import { Loader } from '@googlemaps/js-api-loader'

export default defineComponent({
  name: 'CalendarCard',
  components: {
    IonImg,
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  setup: ({ event }) => {
    const router = useRouter()
    const { activePet } = usePets()

    const isVisitor = computed(() => event?.visitors.find(pet => activePet.value?.id === pet.id) !== undefined)

    const map = ref(null)
    const dateString = ref('')

    const dayNames = ['Vas', 'Hét', 'Ked', 'Sze', 'Csüt', 'Pén', 'Szo']
    const monthNames = [
      'január',
      'február',
      'március',
      'április',
      'május',
      'június',
      'július',
      'augusztus',
      'szeptember',
      'október',
      'november',
      'december',
    ]

    const loader = new Loader({
      apiKey: MAPS_API,
      version: 'weekly',
      libraries: [],
    })

    const goToPet = async petId => {
      await router.push({ name: PET_ROUTE, params: { id: petId } })
    }

    onMounted(async () => {
      if (!event.thumbnail) {
        await loader.load()

        map.value = new window.google.maps.Map(document.getElementById(`event-map-${event.id}`), {
          center: { lat: parseFloat(event.latitude), lng: parseFloat(event.longitude) },
          zoom: 15,
          mapId: '6dfc21d28698beac',
          scaleControl: false,
          zoomControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          keyboardShortcuts: false,
          maxZoom: 15,
          minZoom: 15,
          mapTypeControl: false,
          gestureHandling: 'none',
          clickableIcons: false,
        })

        const markerImage = new window.google.maps.MarkerImage(
          event.is_active
            ? require('@/assets/images/icons/walk/event-active.svg')
            : require('@/assets/images/icons/walk/event-inactive.svg'),
          new window.google.maps.Size(32, 39),
          new window.google.maps.Point(0, 0),
          new window.google.maps.Point(12, 39),
        )

        new window.google.maps.Marker({
          position: { lat: Number(event.latitude), lng: Number(event.longitude) },
          map: map.value,
          optimized: false,
          zIndex: 1,
          icon: markerImage,
        })
      }

      const date = new Date(event.date)

      dateString.value = `${monthNames[date.getMonth()]} ${date.getDate()}. ${dayNames[date.getDay()]}`
    })

    return {
      isVisitor,
      dateString,
      goToPet,
    }
  },
})
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@800&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@900&display=swap');

.event-card {
  width: 100%;
  height: 250px;
  display: flex;
  flex-direction: column;

  &.inactive .footer {
    color: #959595;
  }

  &.hasThumbnail {
    &.inactive {
      .footer {
        padding-bottom: 0;
      }
    }

    .footer .title {
      top: -15px;
    }
  }

  .header {
    flex-grow: 1;
    flex-shrink: 1;
    position: relative;
    border-radius: 31px 31px 0 0;

    &.thumbnail {
      background-size: cover;
    }

    .inactive-event {
      position: absolute;
      inset: 0;
      background: rgba(0, 0, 0, 0.5);
      border-radius: 31px 31px 0 0;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;

      h1 {
        font-family: 'Montserrat', 900;
        font-size: 14px !important;
        line-height: 17.07px;
        letter-spacing: -0.3px;
      }
    }

    .map {
      height: 100%;
      border-radius: 31px 31px 0 0;
    }

    .visit-button {
      position: absolute;
      top: 12px;
      right: 12px;
      width: 35px;
      height: 35px;
      background: #fff;
      border-radius: 9999px;
      box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.15);
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .footer {
    flex-shrink: 0;
    width: 100%;
    height: auto;
    border-radius: 0 0 31px 31px;
    background: white;
    padding: 7px 10px 15px 10px;
    box-shadow: -7px 11px 29px -10px rgba(0, 0, 0, 0.2);

    .title {
      display: flex;
      align-items: flex-end;
      position: relative;

      h1 {
        flex-grow: 1;
        font-family: 'Poppins', sans-serif;
        font-size: 15px !important;
        line-height: 22.5px;
        letter-spacing: -0.3px;
        margin: 0 5px 0 5px !important;
      }

      p {
        color: #9d9d9d;
        font-size: 10px;
        line-height: 22.5px;
        letter-spacing: -0.3px;
        font-family: 'Open Sans', sans-serif;
        font-weight: 400;
        text-align: right;
        margin: 0;
        text-transform: capitalize;
      }
    }

    .visitors {
      display: flex;
      flex-direction: row-reverse;
      justify-content: flex-end;
      padding-left: 10px;
      margin-bottom: -1px;

      .visitor {
        min-width: 20px;
        min-height: 20px;
        max-width: 20px;
        max-height: 20px;
        border-radius: 9999px;
        margin-left: -3px;

        ion-img::part(image) {
          border-radius: 9999px;
        }
      }
    }
  }
}
</style>
